export default __webpack_public_path__ + "6a823f3b70f25cf3d936443f2b40fe4f.svg";